import React from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

const ComingSoonSection = ({ data }) => {
  if (!data || data.enabled === false) return null;
  const items = (data.list || "").split("\n").map((s) => s.trim()).filter(Boolean);
  if (!items.length && !data.intro) return null;

  return (
    <section data-testid="coming-soon-section" className="max-w-5xl mx-auto px-6 py-14 border-t border-black/10 mt-6">
      <div className="flex items-center gap-3 gpm-text-gold mb-2">
        <Clock size={18} />
        <span className="text-xs uppercase tracking-widest">Also available</span>
      </div>
      <h2 className="font-serif-display text-2xl md:text-3xl font-bold gpm-text-green mb-3">{data.title || "Coming Soon"}</h2>
      {data.intro && <p className="text-sm md:text-base text-gray-600 mb-6 max-w-2xl">{data.intro}</p>}
      {items.length > 0 && (
        <ul className="space-y-2 mb-8">
          {items.map((item, i) => (
            <li key={item + i} className="flex items-start gap-3 text-gray-800">
              <ArrowRight size={16} className="gpm-text-gold shrink-0 mt-1" />
              <span className="text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      )}
      <Link to="/contact" data-testid="coming-soon-enquire" className="inline-flex items-center gap-2 px-5 py-2.5 gpm-text-cream text-sm font-semibold uppercase tracking-wide transition-transform hover:-translate-y-0.5" style={{ backgroundColor: "var(--gpm-green)" }}>
        Register your interest <ArrowRight size={15} />
      </Link>
    </section>
  );
};

export default ComingSoonSection;
